import * as Sentry from '@sentry/react';

window.Sentry = Sentry;
